import Header from './Header';
import Footer from './Footer';
import DevBadge from './DevBadge';
import ErrorBoundary from './ErrorBoundary';
import { Canonical, Titled, useDocumentTitle } from './DocumentHead';

export {
  Header,
  Footer,
  DevBadge,
  ErrorBoundary,
  Canonical,
  Titled,
  useDocumentTitle,
};
